import React from "react";
import { useSelector } from "react-redux";
import { selectPartner } from "../store/partnerStore";
import { PARTNER_KEYS } from "../utils/partner";
import { isV2Enabled, V2_SCREEN_KEYS } from "../v2/registry";
import { useSearchParams } from "react-router-dom";

// Partners without a dedicated privacy page fall back to their terms URL.
const PARTNER_URLS = {
  [PARTNER_KEYS.CLALIT]: {
    terms: "https://movement.activetrail.biz/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F--WEB--free-fit",
    privacy: "https://movement.activetrail.biz/freefit-privacy-active",
  },
  [PARTNER_KEYS.MEHUDET]: {
    terms: "https://movement.activetrail.biz/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F-freefit-web-%D7%9E%D7%90%D7%95%D7%97%D7%93%D7%AA-WOW",
    privacy: "https://movement.activetrail.biz/%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA-%D7%A4%D7%A8%D7%98%D7%99%D7%95%D7%AA-%E2%80%93-%D7%90%D7%A4%D7%9C%D7%99%D7%A7%D7%A6%D7%99%D7%99%D7%AA-%D7%9E%D7%90%D7%95%D7%97%D7%93%D7%AA-WOW",
  },
  [PARTNER_KEYS.LEUMIT]: {
    terms: "https://movement.activetrail.biz/תקנון-Freefit-לאומית-FITplus",
  },
  [PARTNER_KEYS.OVDIM_BARI]: {
    terms: "https://movement.activetrail.biz/עובדיםבריא360WEB-freefit",
  },
  [PARTNER_KEYS.MAOFLAAMIT]: {
    terms: "https://movement.activetrail.biz/תקנון-פריפיט-ווב---מעוף-לעמית-fit",
  },
};

function TermsExternal() {
  const partner = useSelector(selectPartner);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  // The V2 ScreenHeader is 48px; 60px is the legacy header's long-standing allowance.
  const headerOffset = isV2Enabled(V2_SCREEN_KEYS.TERMS_EXTERNAL, partner) ? "48px" : "60px";

  const { terms, privacy = terms } = PARTNER_URLS[partner] ?? PARTNER_URLS[PARTNER_KEYS.CLALIT];
  const url = type === "privacy" ? privacy : terms;

  return (
    <div style={{ width: "100%", height: `calc(100vh - ${headerOffset})` }}>
      <iframe
        src={url}
        title="terms"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
}

export default TermsExternal;
